export const transition = {
    ease: [.6, .6, .6, .6],
    duration: .6
}

export const C_WIDTH_CARD_MATERIA = 200;
export const C_HEIGHT_CARD_MATERIA = 200;